import type { FundraisingResponse, UpdateFundraisingRequest } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { EditFundraisingGateway } from './edit-fundraising.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Edit-fundraising endpoints (the same GET /fundraisings/:id +
 * PATCH /fundraisings/:id the flat page used). The draft → snake_case body
 * mapping lives in the shared domain (`toCreateRequest`).
 */
export const httpEditFundraisingGateway: EditFundraisingGateway = {
  loadFundraising: (id: string) => api.get<FundraisingResponse>(`/fundraisings/${id}`),
  updateFundraising: async (id: string, request: UpdateFundraisingRequest) => {
    await api.patch(`/fundraisings/${id}`, request);
  },
  deleteFundraising: async (id: string) => {
    await api.delete(`/fundraisings/${id}`);
  },
};
